import axios from 'axios';
import AuthService from './AuthService';

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

const unwrapArray = (val) => {
  if (val == null) return [];
  if (Array.isArray(val)) return val;
  if (Array.isArray(val.$values)) return val.$values;
  return [];
};

const normalizeNotification = (row) => {
  if (!row || typeof row !== 'object') return row;
  const count = row.count ?? row.Count ?? 1;
  return {
    ids: unwrapArray(row.ids ?? row.Ids),
    date: row.date ?? row.Date,
    count,
    message:
      row.message ??
      row.Message ??
      (count === 1
        ? '1 new lead assigned to you'
        : `${count} new leads assigned to you`),
  };
};

const normalizeNotificationResponse = (raw) => {
  const envelope = raw?.value ?? raw;
  const notifications = unwrapArray(
    envelope?.leadAssignedNotifications ?? envelope?.LeadAssignedNotifications
  ).map(normalizeNotification);

  const totalFromApi =
    envelope?.totalCount ?? envelope?.TotalCount ?? null;
  const totalCount =
    totalFromApi != null
      ? totalFromApi
      : notifications.reduce((sum, n) => sum + (n.count || 0), 0);

  return { totalCount, leadAssignedNotifications: notifications };
};

const NotificationService = {
  getnotifications: async (userId) => {
    try {
      const response = await axios.get(
        `${API_URL}/LeadAssignedNotification/GetLeadAssignedNotificationsByUserId/${userId}`
      );
      return unwrapArray(response.data?.$values ?? response.data).map(
        normalizeNotification
      );
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  getNotificationsByDateAsync: async (userId) => {
    try {
      const response = await axios.get(
        `${API_URL}/LeadAssignedNotification/GetNotificationsByDate/${userId}`
      );
      return unwrapArray(response.data?.$values ?? response.data).map(
        normalizeNotification
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  clearLeadAssignedNotificationById: async (id) => {
    try {
      const response = await axios.put(
        `${API_URL}/LeadAssignedNotification/ClearLeadAssignedNotificationById/${id}`
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        throw new Error(error.response.data);
      }
      throw error;
    }
  },

  getNotificationsByDate: async (userId) => {
    try {
      const response = await axios.get(
        `${API_URL}/LeadAssignedNotification/GetLeadAssignedNotificationsByDate/${userId}`
      );
      return normalizeNotificationResponse(response.data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default NotificationService;
